import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { X } from "lucide-react";

export default function CookieConsent() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem("cree8-cookie-consent");
      if (!consent) {
        const timer = setTimeout(() => setVisible(true), 1500);
        return () => clearTimeout(timer);
      }
    } catch {}
  }, []);

  const handleAccept = () => {
    try { localStorage.setItem("cree8-cookie-consent", "accepted"); } catch {}
    setVisible(false);
  };

  const handleDecline = () => {
    try { localStorage.setItem("cree8-cookie-consent", "declined"); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6 animate-fade-in-up"
      style={{ animationDuration: "0.5s" }}
    >
      <div className="max-w-3xl mx-auto bg-[#1A1A1A]/95 backdrop-blur-xl border border-white/10 rounded-lg p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-2xl">
        <p className="text-sm text-white/70 flex-1 leading-relaxed">
          {t.cookieConsent.text}{" "}
          <Link
            to="/cookies"
            data-testid="cookie-policy-link"
            className="text-[#E8A400] hover:underline"
          >
            {t.cookieConsent.policyLink}
          </Link>
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleDecline}
            data-testid="cookie-decline-btn"
            className="text-sm font-medium text-white/60 hover:text-white border border-white/10 px-5 py-2 rounded-sm transition-colors duration-300"
          >
            {t.cookieConsent.decline}
          </button>
          <button
            onClick={handleAccept}
            data-testid="cookie-accept-btn"
            className="text-sm font-semibold bg-[#E8A400] text-[#1A1A1A] px-5 py-2 rounded-sm hover:bg-[#C68C00] transition-colors duration-300"
          >
            {t.cookieConsent.accept}
          </button>
        </div>
        <button
          onClick={handleDecline}
          className="absolute top-3 right-3 sm:hidden text-white/30 hover:text-white"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
